// extracted by mini-css-extract-plugin
export var typingIndicator = "_pf-0";